import React, { Component } from 'react';
import ControlerenResults from './../../Global/Modules/ControlerenResults'

class Controleren extends Component {
  componentWillMount() {
  }
  render() {
    return (
      <div className="route">
        <h1 className="pageTitle">
          Constructeurs controleren
        </h1>
        <ControlerenResults srch={this.props.location.state === undefined ? this.props.match.params["srch"] === undefined ? "" : this.props.match.params["srch"] : this.props.location.state.message} />
      </div>
    );
  }
}

export default Controleren;



// WEBPACK FOOTER //
// ./src/components/Public/Pages/Controleren.js